export const AdmitTagProfileMap = {
  55: '577artesh',
  37: 'manzarieh',
  63: 'aftabehashtom',
  8: 'kashani',
  24: 'ashrafieisfahani',
  59: 'isfahanclinic',
  10: 'alzahra',
  13: 'imamhossein-isfahan',
  29: 'imamhossein-golpayegan',
  50: 'kheiriehimamkhomeini',
  22: 'imamkhomeini',
  17: 'imammosakazem',
  57: 'amiralmomenin-isfahan',
  21: 'amiralmomenin-shahreza',
  15: 'amin',
  58: 'sadoughi',
  34: 'behnia',
  32: 'booali',
  9: 'chamran',
  51: 'hojatibnelhasaneaskari',
  30: 'heshmatieh',
  78: 'rasouleakram',
  35: 'hazratezahra',
  33: 'hazratemohammad',
  70: 'khatamalanbia',
  44: 'khanevadeh',
  7: 'noor',
  61: 'shariati',
  56: 'gharazi',
  47: 'roz',
  38: undefined,
  52: 'zahrayemarzieh',
  49: 'sepahan',
  45: 'sadi',
  14: 'sayedoshohada-isfahan',
  18: 'sayedoshohada-semirom',
  43: 'sina',
  23: 'shafa',
  20: undefined,
  19: 'shohadaielenjan',
  77: undefined,
  12: 'beheshti',
  31: '179',
  28: 'shahidrajaei',
  60: 'asabvaravaneshahidrajaie',
  42: 'motahary',
  36: 'montazeri',
  69: undefined,
  53: 'askarieh',
  26: 'isabnemaryam',
  11: 'farabi',
  54: 'fatemehzahra',
  39: 'fatemieh-badrud',
  40: 'fatemieh-khansar',
  16: 'feiz',
  25: 'goldis',
  41: 'mohammadrasoulollah',
  27: 'modarres',
  48: 'mehregan',
  46: 'milad',
  62: undefined,
};
